(function () {
  angular
    .module("ROGER")

    .controller("TradeInApprovalController", [
      "$scope",
      "$http",
      "$sessionStorage",
      "$messageBox",
      "$uibModal",
      "Blob",
      "FileSaver",
      "$oidc",
      "$notifications",
      "$translate",
      function (scope, http, sessionStorage, messageBox, uibModal, Blob, FileSaver, oidc, notifications, translate) {
        scope.$storage = sessionStorage;
        scope.filter = {
          orderNumber: null,
          vin: null,
          showAccepted: null
        };

        scope.$watch("$storage.retailer", function (newValue, oldValue) {
          if (oldValue.Id !== newValue.Id && newValue.Id > 0) {
            scope.refresh();
          }
        });

        function _loadTradeIns() {
          return http
            .get(
              "/api/retailer/" +
              scope.$storage.retailer.Id +
              "/trade-in/approval",
              {
                params: scope.filter,
                headers: {
                  Authorization: oidc.current.token_type + " " + oidc.current.access_token
                }
              }
            )
            .then(function (response) {
              scope.list = response.data;
            });
        }

        function _approveTradeIn(tradeInId) {
          return http
            .put(
              "/api/retailer/" +
              scope.$storage.retailer.Id +
              "/trade-in/" +
              tradeInId +
              "/APR",
              null,
              {
                headers: {
                  Authorization: oidc.current.token_type + " " + oidc.current.access_token
                }
              }
            );
        }

        function _returnTradeIn(tradeInId, data) {
          return http
            .put(
              "/api/retailer/" +
              scope.$storage.retailer.Id +
              "/trade-in/" +
              tradeInId +
              "/RET",
              { reason: data },
              {
                headers: {
                  Authorization: oidc.current.token_type + " " + oidc.current.access_token
                }
              }
            );
        }

        scope.downloadAttachments = function (id) {
          _downloadAttachments(id, scope.$storage.retailer.Id);
        }

        function _downloadAttachments(id, retailerId) {
          return http
            .get("/api/retailer/" + retailerId + "/trade-in/" + id + "/attachment/download", {
              responseType: 'arraybuffer',
              headers: {
                Authorization: oidc.current.token_type + " " + oidc.current.access_token
              },
              skipInterceptors: true
            })
            .then(function (response) {
              var contentDisposition = response.headers("content-disposition");
              var regex = /filename="*([^"].+[^"])"*;/g;
              var result = regex.exec(contentDisposition);
              var fileName = result[1];
              var data = new Blob([response.data], { type: response.headers("content-type") });
              FileSaver.saveAs(data, fileName);
            }, function (data) {
              translate(['TradeInAttachmentsDownloadError.Message', 'TradeInAttachmentsDownloadError.Name'])
                .then(function (translations) {
                  notifications.addError(
                    translations['TradeInAttachmentsDownloadError.Name'],
                    translations['TradeInAttachmentsDownloadError.Message']
                  );
                }, function () {
                  notifications.addError(
                    'Error',
                    'An error occured when downloading attachments'
                  );
                })
            });
        }

        scope.approve = function (tradeInId) {
          return _approveTradeIn(tradeInId).then(_loadTradeIns);
        };

        scope.return = function (tradeInId) {
          uibModal
            .open({
              template: require("./ApprovalReturn.html"),
              controller: "ApprovalReturnController"
            })
            .result.then(
              function (data) {
                return _returnTradeIn(tradeInId, data);
              },
              function () { }
            )
            .then(_loadTradeIns);
        };

        scope.getItemStripeClass = function (id) {
          if (id === 1 || id === 2) {
            return "bg-yellow";
          } else if (id === 3) {
            return "bg-green";
          } else if (id === 4 || id === 5) {
            return "bg-red";
          } else {
            return "";
          }
        };

        scope.showDescription = function (description) {
          return messageBox.showConfirm("Description", description, "Ok")
            .result;
        };

        scope.refresh = function () {
          _loadTradeIns();
        };

        if (scope.$storage.retailer !== null && scope.$storage.retailer.Id > 0) {
          scope.refresh();
        }
      }
    ]);
})();
